import React, { useState } from 'react';
import LeftSectionResults from './LeftSectionResults';
import MiddleSection from './MiddleSection';
import RightSection from './RightSection';

const GeneratingResults = () => {
  const [formData, setFormData] = useState({
    nasionToInion: '35',
    preauricular: '35',
    circumference: '35',
    nomenclature: 'T3/T4',
  });

  const handleFormSubmit = (data) => {
    setFormData(data);
  };

  return (
    <section className="homepage results-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-xl-4 col-lg-6 col-md-6 p-0">
            <LeftSectionResults onFormSubmit={handleFormSubmit} formData={formData} />
          </div>
          <div className="col-12 col-xl-4 col-lg-6 col-md-6 p-0 mt-md-0 mt-4">
            <MiddleSection formData={formData} />
          </div>
          <div className="col-12 col-xl-4 col-lg-12 p-0 mt-xl-0 mt-4">
            <RightSection />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GeneratingResults;